import type { AudienceSegmentSetMetrics, CumulativeMetrics } from '@openx/types/gqlTypes';
import type { DealPromptTileStatsProps } from '../parts/tiles/DealPromptTileStats';

export const mapMetricsToTileStats = (
  metrics?: CumulativeMetrics | AudienceSegmentSetMetrics
): DealPromptTileStatsProps => ({
  potentialSpend: (metrics as CumulativeMetrics)?.totalBidSpendInUsd ?? 0,
  marketRequests: (metrics as CumulativeMetrics)?.totalCprMarketRequests ?? 0,
  relevance: metrics?.relevance ?? 0,
  averageCpm: (metrics as CumulativeMetrics)?.avgBidCpm ?? 0,
  impressions: (metrics as CumulativeMetrics)?.totalImpressions ?? 0,
  viewability: (metrics as CumulativeMetrics)?.avgViewability ?? 0,
  activeIPs: (metrics as AudienceSegmentSetMetrics)?.activeIPs ?? 0,
  avgCPM: (metrics as AudienceSegmentSetMetrics)?.avgCPM ?? 0,
  reach: (metrics as AudienceSegmentSetMetrics)?.reach ?? 0,
});
